import {
  GET_GENERAL_SETTINGS_FAILED,
  GET_GENERAL_SETTINGS_INIT,
  GET_GENERAL_SETTINGS_SUCCESS,
  UPDATE_GENERAL_SETTINGS_INIT,
  UPDATE_GENERAL_SETTINGS_SUCCESS,
  UPDATE_GENERAL_SETTINGS_FAILED,
  GET_ROLES_INIT,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAILED,
  GET_SKILLS_INIT,
  GET_SKILLS_SUCCESS,
  GET_SKILLS_FAILED,
  GET_ADMIN_DEPARTMENTS_INIT,
  GET_ADMIN_DEPARTMENTS_SUCCESS,
  GET_ADMIN_DEPARTMENTS_FAILED,
  UPDATE_ROLES_INIT,
  UPDATE_ROLES_SUCCESS,
  UPDATE_ROLES_FAILED,
  UPDATE_SKILLS_INIT,
  UPDATE_SKILLS_SUCCESS,
  UPDATE_SKILLS_FAILED,
  UPDATE_DEPARTMENTS_INIT,
  UPDATE_DEPARTMENTS_SUCCESS,
  UPDATE_DEPARTMENTS_FAILED,
  GET_MANAGERS_INIT,
  GET_MANAGERS_SUCCESS,
  GET_MANAGERS_FAILED,
  GET_PRIORITIES_INIT,
  GET_PRIORITIES_SUCCESS,
  GET_PRIORITIES_FAILED,
  GET_PROJECT_TYPES_INIT,
  GET_PROJECT_TYPES_SUCCESS,
  GET_PROJECT_TYPES_FAILED,
  GET_PM_COMPONENTS_SETTINGS_INIT,
  GET_PM_COMPONENTS_SETTINGS_SUCCESS,
  GET_PM_COMPONENTS_SETTINGS_FAILED,
  GET_RM_COMPONENTS_SETTINGS_INIT,
  GET_RM_COMPONENTS_SETTINGS_SUCCESS,
  GET_RM_COMPONENTS_SETTINGS_FAILED,
  GET_FM_COMPONENTS_SETTINGS_INIT,
  GET_FM_COMPONENTS_SETTINGS_SUCCESS,
  GET_FM_COMPONENTS_SETTINGS_FAILED,
  UPDATE_PM_COMPONENTS_SETTINGS_INIT,
  UPDATE_PM_COMPONENTS_SETTINGS_SUCCESS,
  UPDATE_PM_COMPONENTS_SETTINGS_FAILED,
  UPDATE_RM_COMPONENTS_SETTINGS_INIT,
  UPDATE_RM_COMPONENTS_SETTINGS_SUCCESS,
  UPDATE_RM_COMPONENTS_SETTINGS_FAILED,
  UPDATE_FM_COMPONENTS_SETTINGS_INIT,
  UPDATE_FM_COMPONENTS_SETTINGS_SUCCESS,
  UPDATE_FM_COMPONENTS_SETTINGS_FAILED,
  GET_PM_FIELDS_SETTINGS_INIT,
  GET_PM_FIELDS_SETTINGS_SUCCESS,
  GET_PM_FIELDS_SETTINGS_FAILED,
  GET_RM_FIELDS_SETTINGS_INIT,
  GET_RM_FIELDS_SETTINGS_SUCCESS,
  GET_RM_FIELDS_SETTINGS_FAILED,
  UPDATE_PM_FIELDS_SETTINGS_INIT,
  UPDATE_PM_FIELDS_SETTINGS_SUCCESS,
  UPDATE_PM_FIELDS_SETTINGS_FAILED,
  UPDATE_RM_FIELDS_SETTINGS_INIT,
  UPDATE_RM_FIELDS_SETTINGS_SUCCESS,
  UPDATE_RM_FIELDS_SETTINGS_FAILED,
  GET_DIRECT_EMPLOYEE_DETAILS_INIT,
  GET_DIRECT_EMPLOYEE_DETAILS_SUCCESS,
  GET_DIRECT_EMPLOYEE_DETAILS_FAILED,
  GET_OTHER_DIRECT_INHOUSE_COST_INIT,
  GET_OTHER_DIRECT_INHOUSE_COST_SUCCESS,
  GET_OTHER_DIRECT_INHOUSE_COST_FAILED,
  GET_VENDOR_EMPLOYEE_DETAILS_INIT,
  GET_VENDOR_EMPLOYEE_DETAILS_SUCCESS,
  GET_VENDOR_EMPLOYEE_DETAILS_FAILED,
  GET_VENDOR_RELATED_COST_INIT,
  GET_VENDOR_RELATED_COST_SUCCESS,
  GET_VENDOR_RELATED_COST_FAILED,
  GET_CAPEX_RELATED_EXPENSES_INIT,
  GET_CAPEX_RELATED_EXPENSES_SUCCESS,
  GET_CAPEX_RELATED_EXPENSES_FAILED,
  UPDATE_DIRECT_EMPLOYEE_DETAILS_INIT,
  UPDATE_DIRECT_EMPLOYEE_DETAILS_SUCCESS,
  UPDATE_DIRECT_EMPLOYEE_DETAILS_FAILED,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_INIT,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_SUCCESS,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_FAILED,
  UPDATE_VENDOR_EMPLOYEE_DETAILS_INIT,
  UPDATE_VENDOR_EMPLOYEE_DETAILS_SUCCESS,
  UPDATE_VENDOR_EMPLOYEE_DETAILS_FAILED,
  UPDATE_VENDOR_RELATED_COST_INIT,
  UPDATE_VENDOR_RELATED_COST_SUCCESS,
  UPDATE_VENDOR_RELATED_COST_FAILED,
  UPDATE_CAPEX_RELATED_EXPENSES_INIT,
  UPDATE_CAPEX_RELATED_EXPENSES_SUCCESS,
  UPDATE_CAPEX_RELATED_EXPENSES_FAILED,
  GET_EMPLOYEE_TYPES_LIST_INIT,
  GET_EMPLOYEE_TYPES_LIST_SUCCESS,
  GET_EMPLOYEE_TYPES_LIST_FAILED,
  GET_PROJECT_STATUS_LIST_INIT,
  GET_PROJECT_STATUS_LIST_SUCCESS,
  GET_PROJECT_STATUS_LIST_FAILED,
  GET_FINANCIAL_MANAGEMENT_SETTINGS_INIT,
  GET_FINANCIAL_MANAGEMENT_SETTINGS_SUCCESS,
  GET_FINANCIAL_MANAGEMENT_SETTINGS_FAILED,
  UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_INIT,
  UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_SUCCESS,
  UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_FAILED,
  GET_LOCATION_SETTINGS_INIT,
  GET_LOCATION_SETTINGS_SUCCESS,
  GET_LOCATION_SETTINGS_FAILED,
  UPDATE_LOCATION_SETTINGS_INIT,
  UPDATE_LOCATION_SETTINGS_SUCCESS,
  UPDATE_LOCATION_SETTINGS_FAILED,
  LOGIN_INIT,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGOUT_INIT,
  LOGOUT_SUCCESS,
  LOGOUT_FAILED,
  GET_DELEGATED_DEPARTMENT_HISTORY_INIT,
  GET_DELEGATED_DEPARTMENT_HISTORY_SUCCESS,
  GET_DELEGATED_DEPARTMENT_HISTORY_FAILED,
  GET_DELEGATION_RESOURCE_LIST_INIT,
  GET_DELEGATION_RESOURCE_LIST_SUCCESS,
  GET_DELEGATION_RESOURCE_LIST_FAILED,
  GET_DELEGATION_RESOURCE_FROM_LIST_INIT,
  GET_DELEGATION_RESOURCE_FROM_LIST_SUCCESS,
  GET_DELEGATION_RESOURCE_FROM_LIST_FAILED,
  CREATE_DELEGATE_DEPARTMENT_INIT,
  CREATE_DELEGATE_DEPARTMENT_SUCCESS,
  CREATE_DELEGATE_DEPARTMENT_FAILED,
  NEW_USER_REGISTRATION_INIT,
  NEW_USER_REGISTRATION_SUCCESS,
  NEW_USER_REGISTRATION_FAILED,
  GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_INIT,
  GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_SUCCESS,
  GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_FAILED,
  CREATE_ROLE_FROM_EXCEL_INIT,
  CREATE_ROLE_FROM_EXCEL_SUCCESS,
  CREATE_ROLE_FROM_EXCEL_FAILED,
  DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_INIT,
  DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_SUCCESS,
  DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_FAILED,
  CREATE_DEPARTMENT_FROM_EXCEL_INIT,
  CREATE_DEPARTMENT_FROM_EXCEL_SUCCESS,
  CREATE_DEPARTMENT_FROM_EXCEL_FAILED,
  GET_SSO_RESULT_INIT,
  GET_SSO_RESULT_SUCCESS,
  GET_SSO_RESULT_FAILED,
  GET_EMAIL_SETTINGS_INIT,
  GET_EMAIL_SETTINGS_SUCCESS,
  GET_EMAIL_SETTINGS_FAILED,
  UPDATE_EMAIL_SETTINGS_INIT,
  UPDATE_EMAIL_SETTINGS_SUCCESS,
  UPDATE_EMAIL_SETTINGS_FAILED,
  USER_ACCESS_REPORT_INIT,
  USER_ACCESS_REPORT_SUCCESS,
  USER_ACCESS_REPORT_FAILED,
  DOWNLOAD_USER_ACCESS_REPORT_INIT,
  DOWNLOAD_USER_ACCESS_REPORT_SUCCESS,
  DOWNLOAD_USER_ACCESS_REPORT_FAILED,
  GET_ACTIVITIES_INIT,
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_FAILED,
  SAVE_ACTIVITIES_INIT,
  SAVE_ACTIVITIES_SUCCESS,
  SAVE_ACTIVITIES_FAILED,
  GET_SUBJECTS_INIT,
  GET_SUBJECTS_SUCCESS,
  GET_SUBJECTS_FAILED,
  SAVE_SUBJECTS_INIT,
  SAVE_SUBJECTS_SUCCESS,
  SAVE_SUBJECTS_FAILED,
  DOWNLOAD_ACTIVITIES_INIT,
  DOWNLOAD_ACTIVITIES_SUCCESS,
  DOWNLOAD_ACTIVITIES_FAILED,
  DOWNLOAD_SUBJECTS_INIT,
  DOWNLOAD_SUBJECTS_SUCCESS,
  DOWNLOAD_SUBJECTS_FAILED,
  DOWNLOAD_DEPARTMENTS_INIT,
  DOWNLOAD_DEPARTMENTS_SUCCESS,
  DOWNLOAD_DEPARTMENTS_FAILED,
  GET_USER_DEFAULT_SETTINGS_INIT,
  GET_USER_DEFAULT_SETTINGS_SUCCESS,
  GET_USER_DEFAULT_SETTINGS_FAILED,
  SAVE_USER_DEFAULT_SETTINGS_INIT,
  SAVE_USER_DEFAULT_SETTINGS_SUCCESS,
  SAVE_USER_DEFAULT_SETTINGS_FAILED,
  GET_USER_ACCESS_CHART_INIT,
  GET_USER_ACCESS_CHART_SUCCESS,
  GET_USER_ACCESS_CHART_FAILED,
} from "../actions/types/admin-types";

export const initialState = {
  generalSettingsData: [],
  updateGeneralSettingsData: 0,
  loadingAPI: true,
  rolesData: [],
  skillsData: [],
  adminDepartmentsData: [],
  updateRolesData: 0,
  updateSkillsData: 0,
  updateDepartmentsData: [],
  prioritiesListData: [],
  managersListData: [],
  projectTypesListData: [],
  pmComponentSettingsData: [],
  updatePMComponentSettingsData: 0,
  pmFieldSettingsData: [],
  updatePMFieldSettingsData: 0,
  rmComponentSettingsData: [],
  updateRMComponentSettingsData: 0,
  rmFieldSettingsData: [],
  updateRMFieldSettingsData: 0,
  fmComponentSettingsData: [],
  updateFMComponentSettingsData: 0,
  directEmployeeDetailsData: [],
  updateDirectEmployeeDetailsData: 0,
  otherDirectInhouseCostData: [],
  updateOtherDirectInhouseCostData: 0,
  vendorEmployeeDetailsData: [],
  updateVendorEmployeeDetailsData: 0,
  vendorRelatedCostData: [],
  updateVendorRelatedCostData: 0,
  capexRelatedExpensesData: [],
  updateCapexRelatedExpensesData: 0,
  projectstatusListData: [],
  employeeTypesListData: [],
  getFinancialManagementSettingsData: [],
  updateFinancialManagementSettingsData: [],
  locationSettingsData: [],
  upadteLocationSettingsData: "",
  loginData: [],
  logoutData: [],
  getDelegatedResourceHistoryData: [],
  getResourceListForDelegationData: [],
  createDelegationData: [],
  newUserRegistration: 0,
  downloadCreateRoleTemplateExcelFile: "",
  createRoleFromExcel: [],
  downloadCreateDepartmentTemplateExcelFile: "",
  createDepartmentFromExcel: [],
  resourcesListFromDelegateData: [],
  ssoData: [],
  emailSettingsData: [],
  updatedEmailSettingsData: [],
  userAccessReportData: [],
  downloadUserAccessReportData: "",
  activitiesData: [],
  subjectsData: [],
  updatedActivitiesData: [],
  updatedSubjectsData: [],
  downloadSubjectsData: "",
  downloadActivitiesData: "",
  downloadDepartmentsData: "",
  userDefaultSettingsData: [],
  saveUserDefaultSettingsData: "",
  userAccessChartData: [],
};

const handlers = {
  [GET_GENERAL_SETTINGS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_GENERAL_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    generalSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_GENERAL_SETTINGS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [UPDATE_GENERAL_SETTINGS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [UPDATE_GENERAL_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    updateGeneralSettingsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_GENERAL_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_ROLES_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_ROLES_SUCCESS]: (state, action) => ({
    ...state,
    rolesData: action.response,
    loadingAPI: false,
  }),
  [GET_ROLES_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_SKILLS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_SKILLS_SUCCESS]: (state, action) => ({
    ...state,
    skillsData: action.response,
    loadingAPI: false,
  }),
  [GET_SKILLS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_ADMIN_DEPARTMENTS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_ADMIN_DEPARTMENTS_SUCCESS]: (state, action) => ({
    ...state,
    adminDepartmentsData: action.response,
    loadingAPI: false,
  }),
  [GET_ADMIN_DEPARTMENTS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [UPDATE_ROLES_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [UPDATE_ROLES_SUCCESS]: (state, action) => ({
    ...state,
    updateRolesData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_ROLES_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [UPDATE_DEPARTMENTS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [UPDATE_DEPARTMENTS_SUCCESS]: (state, action) => ({
    ...state,
    updateDepartmentsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_DEPARTMENTS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [UPDATE_SKILLS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [UPDATE_SKILLS_SUCCESS]: (state, action) => ({
    ...state,
    updateSkillsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_SKILLS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_PRIORITIES_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_PRIORITIES_SUCCESS]: (state, action) => ({
    ...state,
    prioritiesListData: action.response,
    loadingAPI: false,
  }),
  [GET_PRIORITIES_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_MANAGERS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_MANAGERS_SUCCESS]: (state, action) => ({
    ...state,
    managersListData: action.response,
    loadingAPI: false,
  }),
  [GET_MANAGERS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_PROJECT_TYPES_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_PROJECT_TYPES_SUCCESS]: (state, action) => ({
    ...state,
    projectTypesListData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_TYPES_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_PM_COMPONENTS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PM_COMPONENTS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    pmComponentSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_PM_COMPONENTS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_RM_COMPONENTS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_RM_COMPONENTS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    rmComponentSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_RM_COMPONENTS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_FM_COMPONENTS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_FM_COMPONENTS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    fmComponentSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_FM_COMPONENTS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_PM_COMPONENTS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_PM_COMPONENTS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    updatePMComponentSettingsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_PM_COMPONENTS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_RM_COMPONENTS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_RM_COMPONENTS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    updateRMComponentSettingsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_RM_COMPONENTS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_FM_COMPONENTS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_FM_COMPONENTS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    updateFMComponentSettingsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_FM_COMPONENTS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_PM_FIELDS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PM_FIELDS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    pmFieldSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_PM_FIELDS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_RM_FIELDS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_RM_FIELDS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    rmFieldSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_RM_FIELDS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_PM_FIELDS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_PM_FIELDS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    updatePMFieldSettingsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_PM_FIELDS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_RM_FIELDS_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_RM_FIELDS_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    updateRMFieldSettingsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_RM_FIELDS_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_DIRECT_EMPLOYEE_DETAILS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_DIRECT_EMPLOYEE_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    directEmployeeDetailsData: action.response,
    loadingAPI: false,
  }),
  [GET_DIRECT_EMPLOYEE_DETAILS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_OTHER_DIRECT_INHOUSE_COST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_OTHER_DIRECT_INHOUSE_COST_SUCCESS]: (state, action) => ({
    ...state,
    otherDirectInhouseCostData: action.response,
    loadingAPI: false,
  }),
  [GET_OTHER_DIRECT_INHOUSE_COST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_VENDOR_EMPLOYEE_DETAILS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_VENDOR_EMPLOYEE_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    vendorEmployeeDetailsData: action.response,
    loadingAPI: false,
  }),
  [GET_VENDOR_EMPLOYEE_DETAILS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_VENDOR_RELATED_COST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_VENDOR_RELATED_COST_SUCCESS]: (state, action) => ({
    ...state,
    vendorRelatedCostData: action.response,
    loadingAPI: false,
  }),
  [GET_VENDOR_RELATED_COST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_CAPEX_RELATED_EXPENSES_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_CAPEX_RELATED_EXPENSES_SUCCESS]: (state, action) => ({
    ...state,
    capexRelatedExpensesData: action.response,
    loadingAPI: false,
  }),
  [GET_CAPEX_RELATED_EXPENSES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_DIRECT_EMPLOYEE_DETAILS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_DIRECT_EMPLOYEE_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    updateDirectEmployeeDetailsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_DIRECT_EMPLOYEE_DETAILS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_OTHER_DIRECT_INHOUSE_COST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_OTHER_DIRECT_INHOUSE_COST_SUCCESS]: (state, action) => ({
    ...state,
    updateOtherDirectInhouseCostData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_OTHER_DIRECT_INHOUSE_COST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_VENDOR_EMPLOYEE_DETAILS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_VENDOR_EMPLOYEE_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    updateVendorEmployeeDetailsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_VENDOR_EMPLOYEE_DETAILS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_VENDOR_RELATED_COST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_VENDOR_RELATED_COST_SUCCESS]: (state, action) => ({
    ...state,
    updateVendorRelatedCostData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_VENDOR_RELATED_COST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_CAPEX_RELATED_EXPENSES_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_CAPEX_RELATED_EXPENSES_SUCCESS]: (state, action) => ({
    ...state,
    updateCapexRelatedExpensesData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_CAPEX_RELATED_EXPENSES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_EMPLOYEE_TYPES_LIST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_EMPLOYEE_TYPES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    employeeTypesListData: action.response,
    loadingAPI: false,
  }),
  [GET_EMPLOYEE_TYPES_LIST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_PROJECT_STATUS_LIST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PROJECT_STATUS_LIST_SUCCESS]: (state, action) => ({
    ...state,
    projectstatusListData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_STATUS_LIST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_FINANCIAL_MANAGEMENT_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_FINANCIAL_MANAGEMENT_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    getFinancialManagementSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_FINANCIAL_MANAGEMENT_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    updateFinancialManagementSettingsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_LOCATION_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_LOCATION_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    locationSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_LOCATION_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_LOCATION_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_LOCATION_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    upadteLocationSettingsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_LOCATION_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [LOGIN_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [LOGIN_SUCCESS]: (state, action) => ({
    ...state,
    loginData: action.response,
    loadingAPI: false,
  }),
  [LOGIN_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [LOGOUT_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [LOGOUT_SUCCESS]: (state, action) => ({
    ...state,
    logoutData: action.response,
    loadingAPI: false,
  }),
  [LOGOUT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DELEGATED_DEPARTMENT_HISTORY_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_DELEGATED_DEPARTMENT_HISTORY_SUCCESS]: (state, action) => ({
    ...state,
    getDelegatedResourceHistoryData: action.response,
    loadingAPI: false,
  }),
  [GET_DELEGATED_DEPARTMENT_HISTORY_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DELEGATION_RESOURCE_LIST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_DELEGATION_RESOURCE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    getResourceListForDelegationData: action.response,
    loadingAPI: false,
  }),
  [GET_DELEGATION_RESOURCE_LIST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DELEGATION_RESOURCE_FROM_LIST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_DELEGATION_RESOURCE_FROM_LIST_SUCCESS]: (state, action) => ({
    ...state,
    resourcesListFromDelegateData: action.response,
    loadingAPI: false,
  }),
  [GET_DELEGATION_RESOURCE_FROM_LIST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CREATE_DELEGATE_DEPARTMENT_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [CREATE_DELEGATE_DEPARTMENT_SUCCESS]: (state, action) => ({
    ...state,
    createDelegationData: action.response,
    loadingAPI: false,
  }),
  [CREATE_DELEGATE_DEPARTMENT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [NEW_USER_REGISTRATION_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [NEW_USER_REGISTRATION_SUCCESS]: (state, action) => ({
    ...state,
    newUserRegistration: action.response,
    loadingAPI: false,
  }),
  [NEW_USER_REGISTRATION_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CREATE_ROLE_FROM_EXCEL_INIT]: (state) => ({
    ...state,
    createRoleFromExcel: [],
    loadingAPI: true,
  }),
  [CREATE_ROLE_FROM_EXCEL_SUCCESS]: (state, action) => ({
    ...state,
    createRoleFromExcel: action.response,
    loadingAPI: false,
  }),
  [CREATE_ROLE_FROM_EXCEL_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_INIT]: (state) => ({
    ...state,
    downloadCreateRoleTemplateExcelFile: "",
    loadingAPI: true,
  }),
  [GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_SUCCESS]: (state, action) => ({
    ...state,
    downloadCreateRoleTemplateExcelFile: action.response,
    loadingAPI: false,
  }),
  [GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_INIT]: (state) => ({
    ...state,
    downloadCreateDepartmentTemplateExcelFile: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_SUCCESS]: (
    state,
    action
  ) => ({
    ...state,
    downloadCreateDepartmentTemplateExcelFile: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CREATE_DEPARTMENT_FROM_EXCEL_INIT]: (state) => ({
    ...state,
    createDepartmentFromExcel: [],
    loadingAPI: true,
  }),
  [CREATE_DEPARTMENT_FROM_EXCEL_SUCCESS]: (state, action) => ({
    ...state,
    createDepartmentFromExcel: action.response,
    loadingAPI: false,
  }),
  [CREATE_DEPARTMENT_FROM_EXCEL_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_SSO_RESULT_INIT]: (state) => ({
    ...state,
    ssoData: [],
    loadingAPI: true,
  }),
  [GET_SSO_RESULT_SUCCESS]: (state, action) => ({
    ...state,
    ssoData: action.response,
    loadingAPI: false,
  }),
  [GET_SSO_RESULT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_EMAIL_SETTINGS_INIT]: (state) => ({
    ...state,
    emailSettingsData: [],
    loadingAPI: true,
  }),
  [GET_EMAIL_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    emailSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_EMAIL_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [UPDATE_EMAIL_SETTINGS_INIT]: (state) => ({
    ...state,
    updatedEmailSettingsData: [],
    loadingAPI: true,
  }),
  [UPDATE_EMAIL_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    updatedEmailSettingsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_EMAIL_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [USER_ACCESS_REPORT_INIT]: (state) => ({
    ...state,
    userAccessReportData: [],
    loadingAPI: true,
  }),
  [USER_ACCESS_REPORT_SUCCESS]: (state, action) => ({
    ...state,
    userAccessReportData: action.response,
    loadingAPI: false,
  }),
  [USER_ACCESS_REPORT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [DOWNLOAD_USER_ACCESS_REPORT_INIT]: (state) => ({
    ...state,
    downloadUserAccessReportData: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_USER_ACCESS_REPORT_SUCCESS]: (state, action) => ({
    ...state,
    downloadUserAccessReportData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_USER_ACCESS_REPORT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_ACTIVITIES_INIT]: (state) => ({
    ...state,
    activitiesData: [],
    loadingAPI: true,
  }),
  [GET_ACTIVITIES_SUCCESS]: (state, action) => ({
    ...state,
    activitiesData: action.response,
    loadingAPI: false,
  }),
  [GET_ACTIVITIES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_SUBJECTS_INIT]: (state) => ({
    ...state,
    subjectsData: [],
    loadingAPI: true,
  }),
  [GET_SUBJECTS_SUCCESS]: (state, action) => ({
    ...state,
    subjectsData: action.response,
    loadingAPI: false,
  }),
  [GET_SUBJECTS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [SAVE_ACTIVITIES_INIT]: (state) => ({
    ...state,
    updatedActivitiesData: [],
    loadingAPI: true,
  }),
  [SAVE_ACTIVITIES_SUCCESS]: (state, action) => ({
    ...state,
    updatedActivitiesData: action.response,
    loadingAPI: false,
  }),
  [SAVE_ACTIVITIES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [SAVE_SUBJECTS_INIT]: (state) => ({
    ...state,
    updatedSubjectsData: [],
    loadingAPI: true,
  }),
  [SAVE_SUBJECTS_SUCCESS]: (state, action) => ({
    ...state,
    updatedSubjectsData: action.response,
    loadingAPI: false,
  }),
  [SAVE_SUBJECTS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [DOWNLOAD_ACTIVITIES_INIT]: (state) => ({
    ...state,
    downloadActivitiesData: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_ACTIVITIES_SUCCESS]: (state, action) => ({
    ...state,
    downloadActivitiesData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_ACTIVITIES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [DOWNLOAD_SUBJECTS_INIT]: (state) => ({
    ...state,
    downloadSubjectsData: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_SUBJECTS_SUCCESS]: (state, action) => ({
    ...state,
    downloadSubjectsData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_SUBJECTS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [DOWNLOAD_DEPARTMENTS_INIT]: (state) => ({
    ...state,
    downloadDepartmentsData: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_DEPARTMENTS_SUCCESS]: (state, action) => ({
    ...state,
    downloadDepartmentsData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_DEPARTMENTS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_USER_DEFAULT_SETTINGS_INIT]: (state) => ({
    ...state,
    userDefaultSettingsData: [],
    loadingAPI: true,
  }),
  [GET_USER_DEFAULT_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    userDefaultSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_USER_DEFAULT_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [SAVE_USER_DEFAULT_SETTINGS_INIT]: (state) => ({
    ...state,
    saveUserDefaultSettingsData: "",
    loadingAPI: true,
  }),
  [SAVE_USER_DEFAULT_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    saveUserDefaultSettingsData: action.response,
    loadingAPI: false,
  }),
  [SAVE_USER_DEFAULT_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_USER_ACCESS_CHART_INIT]: (state) => ({
    ...state,
    userAccessChartData: [],
    loadingAPI: true,
  }),
  [GET_USER_ACCESS_CHART_SUCCESS]: (state, action) => ({
    ...state,
    userAccessChartData: action.response,
    loadingAPI: false,
  }),
  [GET_USER_ACCESS_CHART_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
};

export default function adminReducer(state = initialState, action) {
  const handler = handlers[action.type];
  if (!handler) return state;
  return { ...state, ...handler(state, action) };
}
